export const NICKNAME_PLACEHOLDER = '%nickname%'; // 昵称占位符
export const SCENE = {
    INVITER: 'inviter', // 有邀请关系
    NO_INVITER: 'no_inviter' // 无邀请关系
};
export const INVITER_SOURCE = {
    GLOBAL_CONTENT: 'global_content', // 归因参数
    QUERY: 'query', // 链接查询参数
    CURRENT_USER: 'current_user' // 当前登录用户
};
